import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Button } from "~/atoms/button";
import { AuthLayout } from "../layouts/Auth";

export const RestoreAccount = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AuthLayout
      title={t("settings.2fa.restore.title")}
      description={t("settings.2fa.restore.description")}
    >
      <div className="pt-4">
        <Button onClick={() => navigate("/login")}>
          {t("password.backToLogin")}
        </Button>
      </div>
    </AuthLayout>
  );
};
